var map = {
	"./bg.json": 4901,
	"./cs.json": 9789,
	"./de.json": 9929,
	"./el.json": 7498,
	"./en.json": 790,
	"./es.json": 8563,
	"./et.json": 8034,
	"./fr.json": 844,
	"./hr.json": 4253,
	"./hu.json": 4626,
	"./it.json": 504,
	"./lt.json": 1560,
	"./lv.json": 9071,
	"./pl.json": 5143,
	"./pt.json": 9898,
	"./ro.json": 4691,
	"./sk.json": 1941,
	"./sl.json": 5329,
	"./sr.json": 7931,
	"./tr.json": 2021,
	"./uk.json": 1754
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9259;